import formatValue from 'app/shared/utils/formatValue';

import { ListViewerSpec } from '../../../models/ViewerSpec';

export interface ListViewerVm {
    type: 'list';
    value: string[];
}

export default function buildListViewer(viewer: ListViewerSpec, value: (number | string)[]): ListViewerVm {
    return {
        type: 'list',
        value: value.map((item) => formatValue(item, { type: 'named-value', translationKey: viewer.translationKey })),
    };
}
